<template>
  <div id="app">
    <router-view />
    <div style="height: 5rem;"></div>
    <Tabbar v-model="active" route  v-if="showNav">
      <TabbarItem icon="home-o" to="/home">首页</TabbarItem>
      <TabbarItem icon="search" to="/favorites">收藏夹</TabbarItem>
      <TabbarItem icon="friends-o" to="/directsellslist">我的订单</TabbarItem>
      <TabbarItem icon="setting-o" to="/membercentre">我的</TabbarItem>
    </Tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'

export default {
  data() {
    return {
      active: 0
    }
  },
  components: {
    Tabbar,
    TabbarItem
  },
  computed: {
    showNav () {
      const path = this.$route.path.toString()
      if (path.indexOf('nt') > -1) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}
</style>
